import React, { useEffect } from 'react'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import Form from '../../../../components/Form'
import Assignees from '../../../../components/Form/Items/Assignees'
import Attachments from '../../../../components/Form/Items/Attachment'
import Deadline from '../../../../components/Form/Items/Deadline'
import Description from '../../../../components/Form/Items/Description'
import FolderSelector from '../../../../components/Form/Items/FolderSelector'
import Mandatory from '../../../../components/Form/Items/Mandatory'
import AdditionalSigner from '../../../../components/Form/Items/Signature/AdditionalSigner'
import Title from '../../../../components/Form/Items/Title'
import RequestEsignature from './Form/RequestEsignature'
import UploadSelector from './Form/UploadSelector'

const Content = () => {
  const { originalItem: item, form, initializeForm } = useFormProvider()

  useEffect(() => {
    if (item?.taskType === TaskConfigurationTypes.SignDocuments) {
      initializeForm(TaskConfigurationTypes.SignDocuments)
    } else {
      initializeForm(TaskConfigurationTypes.SendDocumentTemplate)
    }
  }, [])

  if (!form) return null

  return (
    <Form
      items={{
        title: <Title />,
        assignees: <Assignees />,
        uploadSelector: <UploadSelector />,
        folder: <FolderSelector />,
        requestEsignature: <RequestEsignature />,
        additionalSigner: <AdditionalSigner />,
        description: <Description />,
        deadline: <Deadline />,
        attachments: <Attachments />,
        mandatory: <Mandatory />,
      }}
    />
  )
}

export default Content
